export default __webpack_public_path__ + "static/media/grafema_SET_05.349701e6.jpg";